import React, {ReactNode} from "react";

type Props = {
    showCloseButton: boolean,
    title: ReactNode,
    onClose?: () => void,
}

export function ModalHeader({showCloseButton, title, onClose}: Props) {
    return <div className='modal-header'>
        {showCloseButton && <a onClick={() => onClose?.()} className="btn btn-clear float-right"></a>}
        <div className='modal-title h5'>{title}</div>
    </div>;
}
